import styled, { css } from 'styled-components';
import { BreakpointValue, BreakpointValueMap } from '@lendi-ui/breakpoint';
import { Gutter, HAlign, Reverse, VAlign, Wrap } from '@lendi-ui/grid';

import { Direction, directionMixin, gutterMixin, halignMixin, reverseMixin, valignMixin, wrapMixin } from './utils';

export interface StackProps {
  wrap?: BreakpointValue<Wrap> | BreakpointValueMap<Wrap>;
  halign?: BreakpointValue<HAlign> | BreakpointValueMap<HAlign>;
  valign?: BreakpointValue<VAlign> | BreakpointValueMap<VAlign>;
  reverse?: BreakpointValue<Reverse> | BreakpointValueMap<Reverse>;
  gutter?: BreakpointValue<Gutter> | BreakpointValueMap<Gutter>;
  direction?: BreakpointValue<Direction> | BreakpointValueMap<Direction>;
}

export function stack(props: StackProps) {
  return css`
    display: flex;
    ${halignMixin(props)};
    ${valignMixin(props)};
    ${directionMixin(props)};
    ${reverseMixin(props)};
    ${wrapMixin(props)};
    ${gutterMixin(props)};
  `;
}

const Stack = styled.div<StackProps>`
  ${stack}
`;

export default Stack;
